import { render, staticRenderFns } from "./CollectorLogs.vue?vue&type=template&id=24ec3b95"
import script from "./CollectorLogs.vue?vue&type=script&lang=js"
export * from "./CollectorLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ec3b95')) {
      api.createRecord('24ec3b95', component.options)
    } else {
      api.reload('24ec3b95', component.options)
    }
    module.hot.accept("./CollectorLogs.vue?vue&type=template&id=24ec3b95", function () {
      api.rerender('24ec3b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Logs/CollectorLogs.vue"
export default component.exports